import styles from './Topbar.module.scss';
import CompanyAndTitle from './_CompanyAndTitle';
import HomeAndScenarioButtonContainer from './_HomeAndScenarioButtonsContainer';
import RightSection from './_RightSection';
import LinearGradientDivider from 'components/linear-gradient-divider/LinearGradientDivider';
import PropTypes from 'prop-types';
import Settings from './_Settings';

import UserProfile from './_UserProfile';

const Topbar = ({
    navigateTo,
    navMenuItemHovered,
    setNavMenuItemHovered,
    onFiltersChanged
}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.topbar}>
                <CompanyAndTitle />
                <HomeAndScenarioButtonContainer
                    navigateTo={navigateTo}
                    navMenuItemHovered={navMenuItemHovered}
                    setNavMenuItemHovered={setNavMenuItemHovered}
                />
                <LinearGradientDivider
                    topColor={'#222222'}
                    bottomColor={'#FFFFFF'}
                />
                <RightSection navigateTo={navigateTo} />
                <Settings />
                <UserProfile onFiltersChanged={onFiltersChanged} />
            </div>
            <div className={styles.ScenarioNavBar} />
        </div>
    );
};

Topbar.propTypes = {
    navigateTo: PropTypes.func,
    navMenuItemHovered: PropTypes.number,
    setNavMenuItemHovered: PropTypes.func,
    onFiltersChanged: PropTypes.func
};
export default Topbar;
